import getCurrentUserId from '../../firebase/getCurrentUserId';
import firebase from '../../../firebase';

// export default function getExportDownloadUrl(exportId) {
//     const uid = getCurrentUserId();
//     const path = `users/${uid}/exports/${exportId}`;
//     return storage.ref(path).getDownloadURL();
// }

export default async function getExportDownloadUrl(exportId) {
    const uid = getCurrentUserId();
    const firestore = firebase.firestore();
    const doc = await firestore
        .collection('users')
        .doc(uid)
        .collection('exports')
        .doc(exportId)
        .get();

    if (!doc.exists) throw new Error('Export not found');

    const { downloadUrl } = doc.data();
    if (!downloadUrl) throw new Error('Download URL not available');

    return downloadUrl;
}
